/* eslint-disable */

import React , {useState} from  'react';
import logo from './logo.svg';
import './App.css';
import { Navbar, Nav, Container,Carousel } from 'react-bootstrap';
import Data from './data';
import {Link, Route, Switch} from 'react-router-dom';
import Detail from './Detail.js';
import axios from 'axios';


function App() {

  let [shoe, setShoe] = useState(Data);
  let [stock, setStock] = useState([10,11,12]);

  return (
    <div className="App">
      <>
        <Navbar bg="primary" variant="dark">
          <Container>
          <Navbar.Brand href="/">shoe shop</Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="/detail">Detail</Nav.Link>
            {/* <Nav.Link><Link to="/detail">Detail</Link></Nav.Link> */}
            <Nav.Link href="#pricing">Pricing</Nav.Link>
          </Nav>
          </Container>
        </Navbar>
      </>

      <Route exact path="/"> 
      <div className="background12">
        <h3> 20% season off</h3>
        <h1 className="display-4">Get it!</h1>
        <p className="lead">This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.</p>
        <p>It uses utility classes for typography and spacing to space content out within the larger container.</p>
        <p className="lead">
          <a className="btn btn-primary btn-lg" href="#" role="button">Learn more</a>
        </p>
      </div>

      <div className="container">
        <div className="row">
          {
            shoe.map((a,i)=>{
              return <Card shoe={shoe[i]} i={i} key={i}/>
            })
          }
          {/* <Card shoe={shoe[0]} />
          <Card shoe={shoe[1]} />
          <Card shoe={shoe[2]} /> */}
        </div>
      </div>

      <button className="btn btn-primary" onClick={()=>{
        axios.get('https://codingapple1.github.io/shop/data2.json')
        .then((result)=>{
          // console.log(result);
          // console.log([...shoe,...result.data]);
          setShoe([...shoe, ...result.data]);
        })
        .catch(()=>{
          console.log('error');
        })
      }}>더보기</button>

      </Route>
      <Route path="/detail/:id">
        <Detail shoe={shoe} stock={stock} setStock={setStock}/>
      </Route>


      



    </div>
  );
}

function Card(props ) {
  return(
    <div className="col-md-4">
      <img src={'https://codingapple1.github.io/shop/shoes'+(props.i+1)+'.jpg'} width="100%"></img>
      <h4>{props.shoe.title}</h4>
      <p>{props.shoe.content} & {props.shoe.price}</p>
    </div>
  )
}


export default App;
